<div class="container" *ngIf="GID">
    <div *ngIf="!processComplete" class="m-box" style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center;flex-direction: column;">
        <div class="w100" style="display: flex; align-items: center; justify-content: center; width: 100%;">
            <span style="margin-left: 0.3em; align-self: center;">מה ת.ז שלך?</span>
            <span class="t-field t-field--number" style="direction: rtl;">
                <input [(ngModel)]="ID" (ngModelChange)=" resetAll()" class="t-field-text" />
            </span>
            <button  *ngIf="idAttemptsCounter<4"  class="blue-btn" (click)="resetAll();searchPatient()">חפש </button> 
        </div>
        <h2 style="margin-top: 10%;color: red;"   *ngIf="invalidId">תז לא תקינה {{idAttemptsCounter>3 ? ' תז לא תקינה יש לגשת למזכירות':''}}</h2>
    </div>
    <div *ngIf="processComplete" class="m-box" style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center;flex-direction: column;">
        <div class="w100" style="display: flex;flex-direction: column; align-items: center; justify-content: center; width: 100%;">
            <h3>תהליך הקבלה הושלם בהצלחה</h3>
            <h3>  הרופא יודע שהגעת , יש לשבת להמתין לתורך</h3>
        </div>
       
    </div>
    <div *ngIf="notFoundAWL" class="m-box" style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center;flex-direction: column;">
        <div class="w100" style="display: flex;flex-direction: column;  align-items: center; justify-content: center; width: 100%;">
            <h3>לא קיים תור להיום</h3>
            <h3>נא לגשת למזכירות </h3>
        </div>
       
    </div>
</div>